<template>
  <div class="video-box" v-if="videoVisible">
    <div class="content">
      <video class="video" controls>
        <source :src="src" />
        您当前使用的浏览器不支持HTML5视频。
      </video>
      <div class="close-btn" @click="close"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PcHomeVideoBox',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    // 视频地址
    src: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      videoVisible: false,
    }
  },
  watch: {
    visible: function (val) {
      this.videoVisible = val
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
  }
}
</script>

<style lang="scss" scoped>
.video-box {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .5);

  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1200px;
  }

  .video {
    width: 100%;
  }

  .close-btn {
    position: absolute;
    top: -55px;
    right: -5px;
    width: 50px;
    height: 50px;
    cursor: pointer;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 50px;
      height: 5px;
      border-radius: 10px;
      background: #fff;
    }

    &:before {
      transform: rotate(45deg);
    }
    &:after {
      transform: rotate(-45deg);
    }
  }
}
</style>